const COMMON_SIZES = ["sm", "md", "lg"];
const FORM_SIZES = ["sm", "md"];

export { COMMON_SIZES, FORM_SIZES };
